var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FlashMessages',{attrs:{"context":_vm.context}}),_vm._v(" "),_c('NoticeMessage'),_vm._v(" "),_c('OverlayLoader'),_vm._v(" "),_c('SlideInSurvey')],1)}
var staticRenderFns = []

export { render, staticRenderFns }